import { useState } from "react";

const reviews = [
    {
        id: 1,
        name: "John Carter",
        rating: 5,
        verified: true,
        date: "2 days ago",
        title: "Excellent quality!",
        review:
            "Absolutely love this product. Premium finish, fast delivery, and exactly as described. Highly recommended.",
        helpful: 24,
    },
    {
        id: 2,
        name: "Sarah Wilson",
        rating: 4,
        verified: true,
        date: "1 week ago",
        title: "Very Good",
        review:
            "The quality is great and the packaging was excellent. Would definitely buy again.",
        helpful: 11,
    },
    {
        id: 3,
        name: "Michael Lee",
        rating: 3,
        verified: false,
        date: "2 weeks ago",
        title: "Average",
        review:
            "Product is decent for the price. Shipping took longer than expected.",
        helpful: 5,
    },
];

const distribution = [
    { stars: 5, percent: 72 },
    { stars: 4, percent: 18 },
    { stars: 3, percent: 6 },
    { stars: 2, percent: 3 },
    { stars: 1, percent: 1 },
];

const StarRating = ({ rating }) => (
    <div className="flex gap-1">
        {Array.from({ length: 5 }).map((_, i) => (
            <span
                key={i}
                className={`text-lg ${i < rating ? "text-yellow-400" : "text-gray-300"
                    }`}
            >
                ★
            </span>
        ))}
    </div>
);

export default function ProductReviews() {
    const [filter, setFilter] = useState("All");

    return (
        <div className="rounded-xl">
            <div className="">
                <div className="grid gap-10 lg:grid-cols-[340px_1fr]">
                    <div className="">
                        <div className="rounded-3xl bg-white p-8 shadow-sm">
                            <h2 className="text-6xl font-bold">4.8</h2>
                            <div className="mt-3">
                                <StarRating rating={5} />
                            </div>
                            <p className="mt-2 text-gray-500">
                                Based on 129 reviews
                            </p>
                            <div className="mt-8 space-y-4">
                                {distribution.map((item) => (
                                    <div
                                        key={item.stars}
                                        className="flex items-center gap-3"
                                    >
                                        <span className="w-4 text-sm">
                                            {item.stars}
                                        </span>
                                        <div className="h-2 flex-1 rounded-full bg-gray-200 overflow-hidden">
                                            <div
                                                style={{
                                                    width: `${item.percent}%`,
                                                }}
                                                className="h-full rounded-full bg-black"
                                            />
                                        </div>
                                        <span className="w-10 text-right text-sm text-gray-500">
                                            {item.percent}%
                                        </span>
                                    </div>
                                ))}
                            </div>
                            <button className="mt-8 w-full  rounded-xl bg-black py-3 text-white font-semibold hover:bg-gray-800 transition ">
                                Write a Review
                            </button>
                        </div>
                    </div>
                    <div>
                       

                        <div className="space-y-6">

                            {reviews.map((review) => (
                                <div
                                    key={review.id}
                                    className="rounded-3xl bg-white p-8 shadow-sm"
                                >

                                    <div className="flex flex-wrap items-center justify-between gap-4">

                                        <div>

                                            <div className="flex items-center gap-3">

                                                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gray-200 font-bold">
                                                    {review.name.charAt(0)}
                                                </div>

                                                <div>

                                                    <h3 className="font-semibold">
                                                        {review.name}
                                                    </h3>

                                                    <div className="flex items-center gap-3 mt-1">

                                                        <StarRating
                                                            rating={
                                                                review.rating
                                                            }
                                                        />
                                                        {review.verified && (
                                                            <span className="rounded-full bg-green-100 px-3 py-1 text-xs font-medium text-green-700">
                                                                Verified Purchase
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <span className="text-sm text-gray-500">
                                            {review.date}
                                        </span>
                                    </div>
                                    <h4 className="mt-6 text-xl font-semibold">
                                        {review.title}
                                    </h4>
                                    <p className="mt-3 leading-7 text-gray-600">
                                        {review.review}
                                    </p>
                                    <div className="mt-6 flex items-center gap-4">
                                        <button className="rounded-xl border px-4 py-2 text-sm hover:bg-gray-100">
                                            👍 Helpful ({review.helpful})
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}